
import { useI18n } from 'vue-i18n'
import IModal from "@/components/modal/IModal.vue";
import ILoader from "@/components/loader/ILoader.vue";
import IErrorText from "@/components/error/IErrorText.vue";
import StatisticsTable from "@/modules/statistics/components/StatisticsTable.vue";
import { mapActions, mapGetters } from "vuex";
import { RootActions } from "@/store/actions";
import { defineComponent } from "vue";
import { StatisticsActions } from "@/modules/statistics/store/actions";
import { StatisticsGetters } from "@/modules/statistics/store/getters";


export default defineComponent({
  name: "StatisticsScreen",
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  components: {
    IModal,
    ILoader,
    IErrorText,
    StatisticsTable,
  },
  created() {
    this.fetchStatistics();
  },
  computed: {
    ...mapGetters({
      statisticsItems: StatisticsGetters.GET_STATISTICS_ITEMS,
      isLoading: StatisticsGetters.GET_IS_LOADING,
      error: StatisticsGetters.GET_ERROR,
    })
  },
  methods: {
    ...mapActions({
      closeModal: RootActions.RESET_ACTIVE_VIEW,
      fetchStatistics: StatisticsActions.FETCH_STATISTICS,
    }),
  }
})
